import PropTypes from 'prop-types';
import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import classNames from 'classnames';
import Link from 'next/link';
import Hyperlink from 'components/Tailwind/Text/Hyperlink';
import Paragraph from 'components/Text/Paragraph';
import InlineBlock from 'components/Tailwind/Text/InlineBlock';
import InlineEntry from 'components/Text/InlineEntry';
import TextRenderer from 'components/Text/Text';
import { matchCSSModule, applyHashMarkToHexCode } from '@viome/vnxt-nucleus';
import styles from './StickyBanner.module.scss';

const StickyBanner = ({
    stickyBanner,
    stickyType,
    handleCloseBanner,
    bannerActive,
    isPromoActiveBySchedule,
}) => {
    const stickyFields = stickyBanner?.fields || {},
        { style, classes, backgroundColor, fontColor, body } = stickyFields,
        bannerLink = stickyFields?.settings && stickyFields?.settings.url,
        options = {
            renderNode: {
                [BLOCKS.PARAGRAPH]: (node, nodeChildren) =>
                    Paragraph(nodeChildren),
                [BLOCKS.EMBEDDED_ENTRY]: (node) => InlineBlock(node),
                [INLINES.EMBEDDED_ENTRY]: (node) => InlineEntry(node, {}),
                [INLINES.HYPERLINK]: (node) => Hyperlink(node),
            },
            renderMark: {
                [MARKS.BOLD]: (text) => <strong>{text}</strong>,
                [MARKS.ITALIC]: (text) => <em>{text}</em>,
            },
            renderText: (txt) => TextRenderer(txt),
        },
        containsLink = bannerLink && bannerLink.length,
        wrapper = (
            <div
                className={classNames(
                    styles.stickyWrapper,
                    containsLink && styles.link,
                )}
            >
                {documentToReactComponents(body, options)}
            </div>
        ),
        inlineStyles = {
            color: 'ffffff',
        };

    if (backgroundColor) {
        inlineStyles.background = `${applyHashMarkToHexCode(backgroundColor)}`;
    }
    if (fontColor) {
        inlineStyles.color = `${applyHashMarkToHexCode(fontColor)}`;
    }

    const backgroundStyle = style
        ? styles[`bg--${style}`]
        : matchCSSModule(classes, styles);

    return (
        body &&
        bannerActive &&
        isPromoActiveBySchedule && (
            <section
                className={classNames(
                    styles[`stickyBanner${stickyType}`],
                    styles.sticky,
                    backgroundStyle,
                    (style || classes || backgroundColor) && styles.bg,
                    'stickyBanner',
                )}
                style={inlineStyles}
                role="complementary"
            >
                {containsLink ? (
                    <Link href={bannerLink}>{wrapper}</Link>
                ) : (
                    wrapper
                )}
                <button
                    type="button"
                    className={styles.closeBanner}
                    onClick={handleCloseBanner}
                >
                    &times;
                </button>
            </section>
        )
    );
};

StickyBanner.propTypes = {
    stickyBanner: PropTypes.shape({
        fields: PropTypes.shape({
            body: PropTypes.shape({
                nodeType: PropTypes.string.isRequired,
            }),
        }),
    }).isRequired,
};

export default StickyBanner;
